module.exports = __webpack_public_path__ + "logo.png?502f7b4727a2885eebb81a1548d557d0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 41
// module chunks = 0